
import React, { useRef, useState, useEffect } from 'react';


const Modal = ({ isOpen, onRequestClose, children }) => {

    if (!isOpen) return null;

    // モーダル外をクリックした時にモーダルを閉じる
    const handleBackgroundClick = (e) => {
    // モーダルの外側をクリックした場合に閉じる
      if (e.target === e.currentTarget) {
        onRequestClose();
      }
    };

    return (
        <div
        onClick={handleBackgroundClick} // 背景部分をクリックしたときの処理
            style={{
		
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.7)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
            }}
        >
            <div
                style={{
                    backgroundColor: "#fff",
                    padding: "20px",
                    borderRadius: "10px",
                    width: "90%",
                    maxWidth: "600px",
                    position: "relative",
          	    maxHeight: "80vh", // モーダルの高さを80%に制限
                    overflowY: "auto", // 高さを超えたらスクロール
                }}
            >
                {/* ❌ モーダルを閉じるボタン */}
                {/* <button
                    onClick={onClose}
                    style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        background: "red",
                        color: "white",
                        border: "none",
                        borderRadius: "50%",
                        width: "30px",
                        height: "30px",
                        cursor: "pointer",
                    }}
                >
                    ×
                </button> */}

                {children}
            </div>
        </div>
    );
};export default Modal







const buttonStyle = {
  display: 'inline-block',
  textDecoration: 'none',
  background: '#668ad8',
  color: '#FFF',
  borderBottom: 'solid 0px #627295',
  fontSize: '18px',
  animation: 'blink 1s infinite',
  fontFamily: 'auto',

};




// const AppModal = () => {
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   return (
//     <div>
//       <button 
//         style={{
//         ...buttonStyle
//         }}

// 	onClick={() => setIsModalOpen(true)}>
// 	ボタンの名前
// 	</button>

//       <Modal
//         isOpen={isModalOpen}
//         onClose={() => {
//           setIsModalOpen(false);
//         }}
//       >
//         <表示したいコンポーネント />
//       </Modal>
//     </div>
//   );
// };

// export default AppModal;

//わかりやすくするためにTodoAppModalみたいに名前を変えても良い

